import React from 'react';
import { connect } from 'react-redux';
import PT from 'prop-types';
import {
  Modal,
  Checkbox,
  Radio,
  Form,
  Image,
  Button,
} from 'semantic-ui-react';
import debug from 'debug';
import NoSSR from 'react-no-ssr';
import trackIcon from '../../../assets/images/track-icon.svg';
import { selectCustomFormulas, selectDefaultFormula } from '../../../store/reducers/formula';
import { selectControlsState, clearSelectedPlayers } from '../../../store/reducers/tableControls';
import { getTracking, batchTracking } from '../../../store/actions/tracking.actions';
import styles from './TrackPlayerModal.css';

const log = debug('huddle:app:components:TrackPlayerModal');

const mapStateToProps = (state, {players = []}) => ({
  players: !!players.length ? players : selectControlsState(state).selectedPlayers,
  leagues: selectCustomFormulas(state),
  defaultFormula: selectDefaultFormula(state),
  tracking: state.tracking.tracking,
  loggedIn: state.auth.loggedIn,
});
const mapDispatchToProps = dispatch => ({
  doGetTracking: () => dispatch(getTracking),
  clearSelectedPlayers: () => dispatch(clearSelectedPlayers()),
  doSave: (doTrack, dontTrack) => dispatch(batchTracking(doTrack, dontTrack)),
});
class TrackPlayerModal extends React.Component {
  static propTypes = {
    players: PT.arrayOf(PT.shape({
      player: PT.string.isRequired,
    })),
    clearSelectedPlayers: PT.func.isRequired,
    leagues: PT.arrayOf(PT.object),
    defaultFormula: PT.object,
    tracking: PT.shape({
      id: PT.shape({
        mode: PT.string,
        leagues: PT.arrayOf(PT.string),
      }),
    }),
    doGetTracking: PT.func.isRequired,
    doSave: PT.func.isRequired,
    triggerComponent: PT.func.isRequired,
    loggedIn: PT.bool.isRequired,
  }

  static defaultProps = {
    loggedIn: false,
    players: [],
    leagues: [],
    defaultFormula: null,
    tracking: {},
    triggerComponent: () => (
      <button
        className={styles.trackPlayerButton}
      >
        <Image inline spaced src={trackIcon} />Track Player
      </button>
    ),
  }

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      doTrack: {},
      dontTrack: [],
    };
  }

  componentDidMount = () => {
    const { tracking, doGetTracking } = this.props;

    if (!Object.keys(tracking).length) {
      doGetTracking();
    }
  }

  loadTrackedPlayers = () => {
    const { tracking, players = [], defaultFormula } = this.props;

    const doTrack = {};
    if (players.length) {
      players.forEach(({ player_id }) => {
        var modeValue = 'specific';
        if ((typeof tracking[player_id] === 'undefined') || tracking[player_id].leagues.length == 0) {
          //no league association
          modeValue = 'generic';
        }

        const playerTracking = {
          leagues: tracking[player_id] ? tracking[player_id].leagues : [],
          mode: modeValue,
        };
        // if (playerTracking.leagues.indexOf(defaultFormula.id) === -1) {
        //   playerTracking.leagues.push(defaultFormula.id);
        // }
        doTrack[player_id] = playerTracking;
      });
    }
    return doTrack;
  }

  handleOpen = () => {
    let tps = {};
    if (this.props.players.length > 0) {
      tps = this.loadTrackedPlayers();
      this.setState({ modalOpen: true, doTrack: tps });
    }
  }

  handleClose = () => {
    this.setState({ modalOpen: false, doTrack: { }, dontTrack: [] });
  }

  handleSave = () => {
    var player_num = Object.keys(this.state.doTrack)[0];

    const { doSave } = this.props;
    const { doTrack, dontTrack } = this.state;

    // if player is selected for zero leagues but specific leagues
    // radio button is still selected, some ugliness
    if ((typeof this.state.doTrack[player_num] != "undefined") && (this.state.doTrack[player_num].leagues.length == 0) && this.state.doTrack[player_num].mode == 'specific') {
      var doTrack2 = {};
      var dontTrack2 = [player_num];
      doSave(doTrack2, dontTrack2)
      .then(() => {
        this.props.clearSelectedPlayers();
        this.handleClose();
      })
      .catch(e => {
        log(`Error: ${e}`);
      });
    } else {
      doSave(doTrack, dontTrack)
        .then(() => {
          this.props.clearSelectedPlayers();
          this.handleClose();
        })
        .catch(e => {
          log(`Error: ${e}`);
        });
      }
  }

  track = (e, { value }) => {
    const { doTrack, dontTrack, modalOpen } = this.state;
    const { id, mode, league } = JSON.parse(value);
    if (!modalOpen || !id) return;

    switch (mode) {
      case 'specific':
      case 'generic':
        doTrack[id] = { leagues: [], mode: String(mode) };
        dontTrack.splice(dontTrack.indexOf(id), 1);
        break;
      case 'delete':
        if (!dontTrack.includes(id)) {
          dontTrack.push(id);
        }
        delete doTrack[id];
        break;
      default:
        if (!doTrack[id].leagues.includes(league)) {
          doTrack[id].leagues.push(league);
        } else {
          doTrack[id].leagues.splice(doTrack[id].leagues.indexOf(league), 1);
        }
    }
    this.setState({ doTrack, dontTrack });
  }


  stopTracking = (e, { value }) => {
    const { doTrack, dontTrack, modalOpen } = { ...this.state };
    if (!modalOpen) return;

    const id = value;
    dontTrack.push(id);
    if (doTrack[id]) delete doTrack[id];
    this.setState({ doTrack, dontTrack });
  }

  render() {
    const { doTrack, dontTrack, modalOpen } = this.state;
    const { players, leagues, loggedIn, triggerComponent } = this.props;
    const inlineStyle = {
      modal: { // https://github.com/Semantic-Org/Semantic-UI-React/issues/2549
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    };
    if (!players.length) return null;

    return (
      <NoSSR>
        <Modal
          trigger={(
            <span onClick={this.handleOpen}>
              { loggedIn && triggerComponent() }
            </span>
          )}
          size="small"
          open={modalOpen}
          onClose={this.handleClose}
          //style={inlineStyle.modal} // https://github.com/Semantic-Org/Semantic-UI-React/issues/2549
        >
          <Modal.Header className={styles.header}>Select Leagues</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Form>
                {players.map((player, i) => (
                  <div key={player.player_id}>
                    {i > 0 && <hr />}
                    <p>Track {player.player} in which league(s)?</p>
                    <Form.Field>
                      <Radio
                        label={`Track ${player.player} for specific league(s).`}
                        className={styles.RadioLabel}
                        name={`${player.player_id}`}
                        value={JSON.stringify({ id: player.player_id, mode: 'specific' })}
                        checked={doTrack[player.player_id] && doTrack[player.player_id].mode === 'specific'}
                        onChange={this.track}
                      />
                    </Form.Field>
                    {leagues.map(league =>
                      (<Form.Field key={league.id}>
                        <Checkbox
                          label={league.name}
                          value={JSON.stringify({ id: player.player_id, league: league.id })}
                          className={styles.check}
                          disabled={!(doTrack[player.player_id] &&
                          doTrack[player.player_id].mode === 'specific')}
                          checked={doTrack[player.player_id] &&
                            doTrack[player.player_id].leagues.includes(league.id)}
                          onChange={this.track}
                        />
                      </Form.Field>),
                    )}
                    <Form.Field>
                      <Radio
                        label={`Track ${player.player} but not for a specific league(s).`}
                        className={styles.RadioLabel}
                        name={`${player.player_id}`}
                        value={JSON.stringify({ id: player.player_id, mode: 'generic' })}
                        checked={doTrack[player.player_id] && doTrack[player.player_id].mode === 'generic'}
                        onChange={this.track}
                      />
                    </Form.Field>
                    <Form.Field>
                      <Radio
                        label={`Do not track ${player.player}`}
                        className={styles.RadioLabel}
                        name={`${player.player_id}`}
                        value={JSON.stringify({ id: player.player_id, mode: 'delete' })}
                        checked={dontTrack.includes(player.player_id)}
                        onChange={this.track}
                      />
                    </Form.Field>
                  </div>
                ))}
              </Form>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions className={styles.buttonGroup}>
            <Button className={styles.trackPlayerButton} onClick={this.handleSave}>SET PLAYER TRACKING</Button>
            <Button className={styles.cancelButton} onClick={this.handleClose}>CANCEL</Button>
          </Modal.Actions>
        </Modal>
      </NoSSR>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(TrackPlayerModal);



// WEBPACK FOOTER //
// ./src/app/components/TrackPlayerModal/TrackPlayerModal.js